export * from './ich.page';
export * from './ich.page.resolver';
